// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3mNm7","bigColWidth":"Table_bigColWidth__1vyoU","biggerColWidth":"Table_biggerColWidth__maXn6","row":"Table_row__1X7sE","col":"Table_col__2fXfP"};